/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nested-menu[_ngcontent-%COMP%]   [mat-menu-item][_ngcontent-%COMP%]{border-bottom:1px dashed #d3d3d3;font-size:15px}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/nested.menu/nested.menu.item/nested.menu.item.component.scss.shim.ngstyle.js.pre-build-optimizer.js